import { createReducer, on, Action } from '@ngrx/store';

import { LOAD_QUESTIONS_SUCCESS, LOAD_QUESTIONS_FAIL, SET_QUESTION, AD_RESPONSE, CANCEL_CUESTIONNAIRE, NEXT_QUESTION, REMOVE_LAST_RESPONSE, SAVE_QUESTIONS } from './questionnaire.actions';

import { IQuestionnaireStore } from './questionnaire.state';

/**
 * Initial state
 */
export const INITIAL_STATE: IQuestionnaireStore = {
	current: -1,
	questions: [],
	baremos: null,
	refusals: [],
	monoparentalidad: '',
	discapacidad: '',
	responses: {},
	history: [],
	variables: [],
};

/**
 * Creates the reducer
 */
const _questionnaireReducer = createReducer(
	INITIAL_STATE,
	on(CANCEL_CUESTIONNAIRE, state => ({ ...state, ...INITIAL_STATE })),
	on(LOAD_QUESTIONS_SUCCESS, (state, { questions, baremos, refusals }) => ({
		...state,
		questions: [...questions],
		baremos: { ...baremos },
		refusals: [...refusals],
		monoparentalidad: baremos.monoparentalidad,
		discapacidad: baremos.discapacidad,
	})),
	on(LOAD_QUESTIONS_FAIL, state => state),
	on(SET_QUESTION, (state, { payload }) => {
		if (payload === null) {
			return state;
		}

		return { ...state, current: payload };
	}),
	on(SAVE_QUESTIONS, (state, { payload }) => ({ ...state, questions: [...payload] })),
	on(NEXT_QUESTION, (state, { payload }) => ({
		...state,
		history: [...state.history, payload],
	})),
	on(REMOVE_LAST_RESPONSE, state => {
		const history = state.history.slice(0, state.history.length - 1);
		return { ...state, history };
	}),
	on(AD_RESPONSE, (state, { key, value, parent }) => {
		const responses = { ...state.responses };
		responses[key] = value;
		if (parent !== key) {
			responses[parent] = responses[parent] || [];
			responses[parent] = [...responses[parent], value];
		}
		return { ...state, responses };
	}),
);

/**
 * Questionnaire Home reducer
 *
 * @param state home store
 * @param action action
 * @returns home reducer
 */
export const QUESTIONNAIRE_REDUCER = (state: IQuestionnaireStore | undefined, action: Action): any => _questionnaireReducer(state, action as any);
